export class Constants {
  static readonly DATE_FMT = 'dd/MMM/yyyy';
  static readonly DATE_MONTH_FMT = 'MMM,yyyy';
  static readonly DATE_TIME_FMT = `${Constants.DATE_FMT} hh:mm:ss`;

  //RESOURCES
  public static RESOURCE_TABS: string = "Tabs";
  public static RESOURCE_FIELDS: string = "Fields";
  public static RESOURCE_USER_SETUP: string = "User Setup";
  public static RESOURCE_APP: string = "app";
  public static RESOURCE_SECTIONS: string = "Sections";
  public static RESOURCE_GROUPS: string = "Groups";
  public static RESOURCE_SETTINGS: string = "Settings";
  public static RESOURCE_MENU: string = "Menu";
  public static RESOURCE_OTABS: string = "Other Tabs";

  //PERMISSIONS
  public static PERMISSIONS_READ: string = "Read";
  public static PERMISSIONS_EDIT: string = "Edit";
  public static PERMISSIONS_CREATE: string = "Create";
  public static PERMISSIONS_DELETE: string = "Delete";
  public static PERMISSIONS_NONE: string = "None";
  public static PERMISSIONS_ENABLED: string = "Enabled";
  public static PERMISSIONS_DISABLED: string = "Disabled";
  public static PERMISSIONS_YES: string = "Y";
  public static PERMISSIONS_NO: string = "N";
  public static PERMISSIONS_DISPLAY: string = "Display";

  //ASSOCIATE TYPES
  public static ASSOCIATE_TYPE_CONSECRATED: string = 'Consecrated Life';
  public static ASSOCIATE_TYPE_CONSECRATED_MEN: string = 'Consecrated Men';
  public static ASSOCIATE_TYPE_CONSECRATED_WOMEN: string = 'Consecrated Women';
  public static ASSOCIATE_TYPE_PRIEST: string = 'Priest';
  public static ASSOCIATE_TYPE_SEMINARIAN: string = 'Seminarian';
  public static ASSOCIATE_TYPE_HR: string = 'Human Resources';
  public static ASSOCIATE_TYPE_VOLUNTEER: string = 'Volunteer';
  public static ASSOCIATE_TYPE_CONTRACTOR: string = 'Contractor';
  public static ASSOCIATE_TYPE_Employee: string = 'Employee';
  public static ASSOCIATE_TYPE_NUN: string = 'Nun';
  public static ASSOCIATE_GENDER_MALE: string = 'Male';
  public static ASSOCIATE_GENDER_FEMALE: string = 'Female';
  public static ASSOCIATE_TYPE_DEACON: string = 'Deacon';

   //Applicaiton name "appName"

   public static APP_NAME_CONSECRATED = "consecrated";
   public static APP_NAME_SEMINARIAN = "seminarian";
   public static APP_NAME_PRIEST ="priest";
   public static APP_NAME_DEACON: string = 'deacon';
   public static APP_NAME_HUMANRESOURCES = "humanresources";
   public static APP_NAME_MTP_FINGERPRINT_ADMIN = "mtpadmins";

   // profile name
   public static PROFILE_NAME_PRIEST_FINGERPRINT_ADMIN = "priest-fingerprint-admin";
   public static PROFILE_NAME_SEMINARIAN_FINGERPRINT_ADMIN = "seminarian-fingerprint-admin";

  // MAIL CATEGORY 
  public static MAIL_CATEGORY_SECONDARY: string = 'secondary';
  public static MAIL_CATEGORY_PRIMARY: string = 'primary';
  
  public static MAIL_CATEGORY_WORK: string = 'work';
  public static MAIL_CATEGORY_PERSONAL: string = 'personal'; 
  public static MAIL_CATEGORY_DIOCESAN: string = 'diocesan';
  public static MAIL_CATEGORY_LOGIN: string = 'apploginemail';
  public static MAIL_IS_ACTIVE_YES: string = "Y";
  public static MAIL_IS_ACTIVE_NO: string = "N";

  //Priefix ans Suffix
  public static PREFIX = "Prefix";
  public static SUFFIX = "Suffix"; 

  //PHONE CATEGORY
  public static PHONE_CATEGORY_HOME:string = 'Home';
  public static PHONE_CATEGORY_CELL:string = 'Mobile';
  public static PHONE_CATEGORY_PREFERRED_HOME:string = 'Preferred Home';
  public static PHONE_CATEGORY_PREFERRED_CELL:string = 'Preferred Mobile';
  public static PHONE_CATEGORY_PRIVATE_HOME:string = 'Private Home';
  public static PHONE_CATEGORY_PRIVATE_CELL:string = 'Private Mobile';
  public static PHONE_CATEGORY_WORK:string = 'Work';
  public static PHONE_CATEGORY_WORK_MOBILE:string = 'Work Mobile';
  public static PHONE_IS_ACTIVE_YES: string = "Y";
  public static PHONE_IS_ACTIVE_NO: string = "N";
  public static PHONE_CATEGORY_FAXNUMBER:string ='Fax';

  //API RESPONSE TYPE
  public static API_RESPONSE_TYPE_SUCCESS: string = 'Success';
  public static API_RESPONSE_TYPE_WARNING: string = 'Warning';

  //TOASTER RESPONSE TYPE
  public static TOASTER_RESPONSE_TYPE_SUCCESS: string = 'Success';
  public static TOASTER_RESPONSE_TYPE_ERROR: string = 'Error';
  public static TOASTER_RESPONSE_TYPE_INFO: string = 'Info';
  public static TOASTER_TYPE_FAILURE: string = 'Failure';
  public static TOASTER_TYPE_WARNING: string = 'Warning';
  
  //COMMUNITY
  public static COMMUNITY_COMMUNITY_NAME : string = 'communityName';
  public static COMMUNITY_HOUSE_NAME : string = 'houseName';
  public static COMMUNITY_PLACE_OF_MINISTRY_NAME : string = 'placeOfMinistryName';
  public static COMMUNITY_CONSECRATED_LIFE_TYPE_NAME : string = 'consecratedLifeTypeName';

  //STATUS  
  public static IS_ACTIVE_YES: string = "Y"; 
  public static IS_ACTIVE_NO: string = "N"; 
  public static STATUS_IS_ACTIVE: string = "Active"; 
  public static STATUS_IN_ACTIVE: string = "Inactive";
  public static STATUS_DE_ACTIVE: string = "Deactive";


 //OPTION 
  public static OPTION_SELECT: string = "Select"; 
  public static OPTION_ALL: string = "All";
  public static OPTION_SELECTId: number = 0; 
  public static OPTION_OTHER="Other";
  public static OPTION_OTHER_PREFERENCES="Other Preferences";
  //Appplication names
  public static APPLICATION_CONSECRATED: string = "consecrated";
  public static APPLICATION_FINGERPRINT: string = "fingerprint";
  public static APPLICATION_SEMINARIAN: string = "seminarian";
  public static APPLICATION_PRIEST: string = "priest";
  public static APPLICATION_DEACON: string = "deacon";
  public static APPLICATION__HUMANRESOURCES: string = "humanresources";

  //FingerPrint Address

  public static ADDRESS_TYPE_CURRENT:string="Current";
  public static ADDRESS_TYPE_PREVIOUS:string="Previous";
  public static ADDRESS_TYPE_HOME:string="Home";
  public static ADDRESS_TYPE_BUSINESS: string = "Business";
  public static ADDRESS_TYPE_MAIL: string="Mailing";
  public static ADDRESS_TYPE_OTHER="Other";

  //ORGANIZATION DETAILS CONTACT NUMBER 
  public static RECORD_CUSTODIAN_CONTACTNUMBER: string = "Contact"; 
  public static SAFE_ENVIROMENT_CONTACTNUMBER: string = "Contacts";

  //Request Status
  public static REQUEST_STATUS_DRAFT: string = "Draft";
  public static REQUEST_STATUS_SUBMIT: string = "Submit";

  //Safe Env Status
  public static SAFE_STATUS_COMPLETED_TRAINING_OK: string = "Completed - Training OK";
  public static SAFE_STATUS_NEEDS_TRAINING: string = "Needs Training";
  public static SAFE_STATUS_RETRAINING: string = "Re-training";
  public static SAFE_STATUS_RETRAINIG_WITHIN_3_MONTHS: string = "Re-training < 3 mos.";
  public static SAFE_STATUS_PARTIAL_TRAINING_OK: string = "Partial - Training OK";

  //Work With YES NO
  public static WORK_WITH_YES: string = "Yes";
  public static WORK_WITH_NO: string = "No";

//FP STATUS  
public static STATUS_PENDING_FP: string = "Pending FP";
public static STATUS_PENDING_BG: string = "Pending BG";

//Priest In  incardinatedOutsideOrange
public static IN_CARDINATED_ORANGE: string = "No";
public static IN_CARDINATED_OUTSIDE_ORANGE: string = "Yes";

//CONSECRATED STATUS  
public static CONSECRATED_ACTIVE: string = "Active"; 
public static CONSECRATED_LEFT_DIOCESES: string = "Left Dioceses";
public static CONSECRATED_DECEASED: string = "Deceased";

//MINISTRY TYPE
public static MINISTRY_TYPE_SCHOOL: string = "School"; 
public static MINISTRY_TYPE_CHURCH: string = "Church";

//APP ID
public static CONSECRATED_APP_ID: string = '10001';
public static FINGERPRINT_APP_ID: string = '10002';
public static SEMINARIAN_APP_ID: string = '10003';
public static PRIEST_APP_ID: string = '10004';
public static DEACON_APP_ID: string = '10008';
public static HUMANRESOURCES_APP_ID: string = '10007';

//NOTES TYPE
public static NOTES_TYPE_GENERAL: string = "general"; 
public static NOTES_TYPE_HEALTH: string = "health";


//TYPE EMPLOYEE
public static TYPE_EMPLOYEE: string = 'Employee';
public static TYPE_NON_EMPLOYEE: string = 'Non-Employee';

//TYPE CHECKLIST
public static TYPE_CHECKLIST_INQUIRER: string = 'Inquirer';
public static TYPE_CHECKLIST_PRE_ORDINATION: string = 'Pre-Ordination';
public static TYPE_CHECKLIST_ROUND_TABLES: string = 'Round Tables';

public static ORG_LISTING_PAGE= "ORG_LISTING_PAGE";
}